<template>
  <v-container>
    <v-form v-model="valid" @submit.prevent="submitForm">
      <v-card>
        <v-card-title class="display-1"
          >Air Transportation Schedule</v-card-title
        >
        <v-card-text>
          <p>
            This form is to report air travel to and from the Rapid City
            Regional Airport for participation in the Dinosaur Project. If you
            are traveling to or from a different airport (as an example,
            arriving at DFW prior to the expedition leaving Keene), then contact
            the project directors via e-mail with the flight information.
          </p>
          <v-container style="padding:0;margin:0;">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="appointment.name"
                  label="Name"
                  autofocus
                  filled
                  required
                  :rules="rules.name"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="appointment.email"
                  label="Email"
                  filled
                  required
                  :rules="rules.email"
                />
              </v-col>
              <v-col cols="12">
                <h2 class="title">Arrival</h2>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="appointment.arrival"
                  label="Date &amp; Time (E.g. 06/05/2020 5:00 pm)"
                  filled
                  :hint="formatDate(appointment.arrival)"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  v-model="appointment.arrivalAirline"
                  label="Airline"
                  filled
                  :items="airlines"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="appointment.arrivalFlight"
                  label="Flight"
                  filled
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  v-model="appointment.arrivalFrom"
                  label="From"
                  filled
                  :items="from"
                />
              </v-col>
              <v-col cols="12">
                <h2 class="title">Departure</h2>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="appointment.departure"
                  label="Date &amp; Time (E.g. 07/01/2020 5:00 pm)"
                  filled
                  :hint="formatDate(appointment.departure)"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  v-model="appointment.departureAirline"
                  label="Airline"
                  filled
                  :items="airlines"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="appointment.departureFlight"
                  label="Flight"
                  filled
                />
              </v-col>
              <v-col cols="12">
                <h2 class="title">Flight Notes</h2>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="appointment.notes"
                  label="Notes"
                  filled
                  counter="500"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-progress-circular
            v-if="loading"
            indeterminate
            color="secondary"
            class="mr-2"
          ></v-progress-circular>
          <v-btn
            large
            color="secondary"
            :disabled="!valid || loading"
            @click="submitForm"
          >
            <v-icon class="mr-1">mdi-cloud-upload</v-icon> Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <v-snackbar v-model="hasMessage" :color="messageType" multi-line>
      {{ message }}
      <v-btn text icon @click="hasMessage = false"
        ><v-icon>mdi-close</v-icon></v-btn
      >
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from '@/axios'
import moment from 'moment'
export default {
  name: 'Home',
  data() {
    return {
      hasMessage: false,
      message: null,
      messageType: 'error',
      loading: false,
      valid: true,
      appointment: {},
      rules: {
        name: [v => !!v || 'Name is required'],
        email: [
          v => !!v || 'Email is required',
          v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Invalid email'
        ],
        arrival: [
          v =>
            moment(v, 'M/D/YYYY h:mm a').isValid() ||
            'Invalid arrival date & time'
        ],
        departure: [
          v =>
            moment(v, 'M/D/YYYY h:mm a').isValid() ||
            'Invalid departure date & time'
        ]
      },
      airlines: ['Allegiant', 'American', 'Delta', 'United'],
      from: [
        'Chicago',
        'Dallas/Fort Worth',
        'Denver',
        'Las Vegas',
        'Minneapolis/St. Paul',
        'Phoenix',
        'Salt Lake City'
      ],
      year: this.$route.params.year
    }
  },
  created() {},
  methods: {
    async submitForm() {
      let arrival, departure
      if (this.appointment.arrival) {
        arrival = moment.utc(this.appointment.arrival, 'M/D/YYYY h:mm a')
        if (!arrival.isValid()) {
          this.message = 'Please provide a valid arrival date & time'
          this.messageType = 'error'
          this.hasMessage = true
          return
        }
        if (!this.appointment.arrivalAirline) {
          this.message = "Please provide the airline you'll be arriving in"
          this.messageType = 'error'
          this.hasMessage = true
          return
        }
        if (!this.appointment.arrivalFlight) {
          this.message =
            "Please provide the flight number you'll be arriving in"
          this.messageType = 'error'
          this.hasMessage = true
          return
        }
        if (!this.appointment.arrivalFrom) {
          this.message = "Please provide where's your flight coming from"
          this.messageType = 'error'
          this.hasMessage = true
          return
        }
      }
      if (this.appointment.departure) {
        departure = moment.utc(this.appointment.departure, 'M/D/YYYY h:mm a')
        if (!departure.isValid()) {
          this.message = 'Please provide a valid departure date & time'
          this.messageType = 'error'
          this.hasMessage = true
          return
        }
        if (!this.appointment.departureAirline) {
          this.message = 'Please provide the departure airline'
          this.messageType = 'error'
          this.hasMessage = true
          return
        }
        if (!this.appointment.departureFlight) {
          this.message = 'Please provide the departure flight number'
          this.messageType = 'error'
          this.hasMessage = true
          return
        }
      }
      if (!arrival && !departure) {
        this.message = 'Please provide the arrival or departure information'
        this.messageType = 'error'
        this.hasMessage = true
        return
      }
      try {
        this.loading = true
        let schedule = Object.assign(
          {
            year: this.year,
            notes: this.notes
          },
          this.appointment
        )
        if (arrival) {
          schedule.arrival = arrival.format()
        }
        if (departure) {
          schedule.departure = departure.format()
        }

        schedule.token = await this.recaptchaToken()

        await axios.post(
          `/api/v1/transportation/${this.year}/airport`,
          schedule
        )
        this.$router.replace({ name: 'Thanks' })
      } catch (err) {
        console.error('Could not schedule appointment: ', err)
      } finally {
        this.loading = false
      }
    },
    formatDate(val) {
      if (!val) {
        return 'Invalid date'
      }
      return moment.utc(val).format('ddd, MMM Do YYYY hh:mm a')
    },
    formatTime(val) {
      return moment.utc(val).format('hh:mm a')
    },
    async recaptchaToken() {
      return new Promise((resolve, reject) => {
        grecaptcha.ready(async () => {
          try {
            const token = await grecaptcha.execute(
              '6LfjlIgUAAAAAK65zLAnAymHiXjuZIH2h9Lxflng'
            )
            resolve(token)
          } catch (err) {
            reject(err)
          }
        })
      })
    }
  }
}
</script>
